import initialState from './initial-state';
import { SET_SECTION, SET_SECTION_ERROR } from '../actions/action-types';
import { createReducer } from './reducer-creator';

const setCustomSeccion = (state, { payload }) => {
  return {
    ...state,
    ready: true,
    error: false,
    raw: payload,
  };
};

const setCustomSeccionError = (state) => {
  return {
    ...state,
    ready: true,
    error: true,
    raw: {},
  };
};

export default createReducer(initialState.sectionState, {
  [SET_SECTION]: setCustomSeccion,
  [SET_SECTION_ERROR]: setCustomSeccionError,
});
